"use client";
/* Auto-generated. Do not edit. */
/* Source: src/pages/home-modules/home-four/sections/doctorSection.tsx */

import { SmartImage } from "@/Components";
import { SmartLink } from "@/Components";
import { renderCollectionNode, renderItemNode, renderNode } from "@/Templates/section-node-renderers";
import { FC, ComponentProps, Key, ReactNode } from "react";

type DoctorSection36FadeInUpsItem = {
    key: Key | null | undefined;
    /** Detected variants: "/Templates/Doccure/img/doctors/pediatric-doctor-01.png" | "/Templates/Doccure/img/doctors/pediatric-doctor-02.png" | "/Templates/Doccure/img/doctors/pediatric-doctor-03.png" | "/Templates/Doccure/img/doctors/pediatric-doctor-04.png" */
    src: string;
    /** Detected variants: "Dr. David Brooks" | "Dr. Jessica Nguyen" | "Dr. Liam Anderson" | "Dr. Emily Carter" */
    link0Text: ReactNode;
    /** Detected variants: "Pediatric Specialist" | "Senior Pediatric Consultant" | "Adolescent Health Consultant" | "Pediatric Nutrition" */
    p0Text: ReactNode;
    /** Detected variants: "col-xl-3 col-md-6 d-flex wow fadeInUp" */
    className?: string;
    /** Detected variants: "0.2s" */
    dataWowDelay?: string;
    /** Detected variants: "1s" */
    dataWowDuration?: string;
    /** Detected variants: "doctor-item-four flex-fill" */
    div0ClassName?: string;
    /** Detected variants: "doctor-image" */
    div0ClassName2?: string;
    /** Detected variants: "all_routes.doctorProfile1" */
    href?: string;
    /** Detected variants: "doctor" */
    alt?: string;
    /** Detected variants: "img-fluid" */
    imageWithBasePath0ClassName?: string;
    /** Detected variants: "doctor-info" */
    div1ClassName?: string;
    /** Detected variants: "custom-title" */
    h30ClassName?: string;
    /** Detected variants: "all_routes.doctorProfile1" */
    link0Href?: string;
};
export type HomeFourDoctorSectionGeneratedProps = {
    divDiv0Div0Link0LinkProps?: Partial<ComponentProps<typeof SmartLink>> | ((item: DoctorSection36FadeInUpsItem) => Partial<ComponentProps<typeof SmartLink>>);
    divDiv0Div0Link0ImageWithBasePath0ImageProps?: Partial<Omit<ComponentProps<typeof SmartImage>, "src" | "alt" | "cover" | "objectFit">> | ((item: DoctorSection36FadeInUpsItem) => Partial<Omit<ComponentProps<typeof SmartImage>, "src" | "alt" | "cover" | "objectFit">>);
    divDiv0Div1H30H3Props?: Partial<ComponentProps<"h3">> | ((item: DoctorSection36FadeInUpsItem) => Partial<ComponentProps<"h3">>);
    divDiv0Div1H30Link0LinkProps?: Partial<ComponentProps<typeof SmartLink>> | ((item: DoctorSection36FadeInUpsItem) => Partial<ComponentProps<typeof SmartLink>>);
    /** Default: "Team Members" */
    sectionDiv0Div0Div0DivText?: ReactNode;
    /** Default: "Meet Our" */
    sectionDiv0Div0H20H2Text?: ReactNode;
    sectionDiv0Div0H20H2Visible?: boolean;
    sectionDiv0Div0H20H2Renderer?: (defaultNode: ReactNode) => ReactNode;
    sectionDiv0Div0H20H2Props?: Partial<ComponentProps<"h2">>;
    /** Default: "Professionals" */
    sectionDiv0Div0H20Span0SpanText?: ReactNode;
    sectionDiv0Div1ClassName?: string;
    doctorSection36FadeInUps: DoctorSection36FadeInUpsItem[];
    doctorSection36FadeInUpsItemWrapper?: (item: DoctorSection36FadeInUpsItem, content: ReactNode) => ReactNode;
    doctorSection36FadeInUpsRenderer?: (defaultNode: ReactNode) => ReactNode;
    doctorSection36FadeInUpsLinkVisible?: boolean;
    doctorSection36FadeInUpsLinkRenderer?: (item: DoctorSection36FadeInUpsItem, defaultNode: ReactNode) => ReactNode;
    doctorSection36FadeInUpsImageVisible?: boolean;
    doctorSection36FadeInUpsImageRenderer?: (item: DoctorSection36FadeInUpsItem, defaultNode: ReactNode) => ReactNode;
    doctorSection36FadeInUpsH3Visible?: boolean;
    doctorSection36FadeInUpsH3Renderer?: (item: DoctorSection36FadeInUpsItem, defaultNode: ReactNode) => ReactNode;
    doctorSection36FadeInUpsLinkProps?: Partial<ComponentProps<typeof SmartLink>> | ((item: DoctorSection36FadeInUpsItem) => Partial<ComponentProps<typeof SmartLink>>);
    doctorSection36FadeInUpsImageProps?: Partial<Omit<ComponentProps<typeof SmartImage>, "src" | "alt" | "cover" | "objectFit">> | ((item: DoctorSection36FadeInUpsItem) => Partial<Omit<ComponentProps<typeof SmartImage>, "src" | "alt" | "cover" | "objectFit">>);
    doctorSection36FadeInUpsH3Props?: Partial<ComponentProps<"h3">> | ((item: DoctorSection36FadeInUpsItem) => Partial<ComponentProps<"h3">>);
};

const HomeFourDoctorSectionGenerated: FC<HomeFourDoctorSectionGeneratedProps> = ({
    sectionDiv0Div0Div0DivText = "Team Members",
    sectionDiv0Div0H20H2Text = "Meet Our",
    sectionDiv0Div0H20H2Visible,
    sectionDiv0Div0H20H2Renderer,
    sectionDiv0Div0H20H2Props,
    sectionDiv0Div0H20Span0SpanText = "Professionals",
    divDiv0Div0Link0ImageWithBasePath0ImageProps,
    divDiv0Div0Link0LinkProps,
    divDiv0Div1H30H3Props,
    divDiv0Div1H30Link0LinkProps,
    sectionDiv0Div1ClassName,
    doctorSection36FadeInUps,
    doctorSection36FadeInUpsItemWrapper,
    doctorSection36FadeInUpsRenderer,
    doctorSection36FadeInUpsLinkVisible,
    doctorSection36FadeInUpsLinkRenderer,
    doctorSection36FadeInUpsImageVisible,
    doctorSection36FadeInUpsImageRenderer,
    doctorSection36FadeInUpsH3Visible,
    doctorSection36FadeInUpsH3Renderer,
    doctorSection36FadeInUpsLinkProps,
    doctorSection36FadeInUpsImageProps,
    doctorSection36FadeInUpsH3Props,
}) => {
    return (
        <section className="doctor-section-four section">
            <div className="container">
                <div className="section-header section-header-four text-center">
                    <div className="section-sub-title">{sectionDiv0Div0Div0DivText}</div>
                    {renderNode(sectionDiv0Div0H20H2Visible, sectionDiv0Div0H20H2Renderer, (
                        <h2 className="section-title" {...(sectionDiv0Div0H20H2Props ?? {})}>
                            {sectionDiv0Div0H20H2Text}
                            <span>{sectionDiv0Div0H20Span0SpanText}</span>
                        </h2>
                    ))}
                </div>
                <div className={sectionDiv0Div1ClassName ?? "row g-4"}>
                    {renderCollectionNode(
                        doctorSection36FadeInUps,
                        (item: DoctorSection36FadeInUpsItem) => (
                            <div className={item.className ?? "col-xl-3 col-md-6 d-flex wow fadeInUp"} data-wow-delay={item.dataWowDelay ?? "0.2s"} data-wow-duration={item.dataWowDuration ?? "1s"} key={item.key}>
                                <div className={item.div0ClassName ?? "doctor-item-four flex-fill"}>
                                    <div className={item.div0ClassName2 ?? "doctor-image"}>
                                        {renderItemNode(doctorSection36FadeInUpsLinkVisible, doctorSection36FadeInUpsLinkRenderer, item, (
                                            <SmartLink href={item.href ?? "all_routes.doctorProfile1"} {...(typeof doctorSection36FadeInUpsLinkProps === "function" ? doctorSection36FadeInUpsLinkProps(item) : (doctorSection36FadeInUpsLinkProps ?? {}))} {...(typeof divDiv0Div0Link0LinkProps === "function" ? divDiv0Div0Link0LinkProps(item) : (divDiv0Div0Link0LinkProps ?? {}))}>
                                                {renderItemNode(doctorSection36FadeInUpsImageVisible, doctorSection36FadeInUpsImageRenderer, item, (
                                                    <SmartImage src={item.src} alt={item.alt ?? "doctor"} className={item.imageWithBasePath0ClassName ?? "img-fluid"} {...(typeof doctorSection36FadeInUpsImageProps === "function" ? doctorSection36FadeInUpsImageProps(item) : (doctorSection36FadeInUpsImageProps ?? {}))} {...(typeof divDiv0Div0Link0ImageWithBasePath0ImageProps === "function" ? divDiv0Div0Link0ImageWithBasePath0ImageProps(item) : (divDiv0Div0Link0ImageWithBasePath0ImageProps ?? {}))} />
                                                ))}
                                            </SmartLink>
                                        ))}
                                    </div>
                                    <div className={item.div1ClassName ?? "doctor-info"}>
                                        {renderItemNode(doctorSection36FadeInUpsH3Visible, doctorSection36FadeInUpsH3Renderer, item, (
                                            <h3 className={item.h30ClassName ?? "custom-title"} {...(typeof doctorSection36FadeInUpsH3Props === "function" ? doctorSection36FadeInUpsH3Props(item) : (doctorSection36FadeInUpsH3Props ?? {}))} {...(typeof divDiv0Div1H30H3Props === "function" ? divDiv0Div1H30H3Props(item) : (divDiv0Div1H30H3Props ?? {}))}>
                                                {renderItemNode(doctorSection36FadeInUpsLinkVisible, doctorSection36FadeInUpsLinkRenderer, item, (
                                                    <SmartLink href={item.link0Href ?? "all_routes.doctorProfile1"} {...(typeof doctorSection36FadeInUpsLinkProps === "function" ? doctorSection36FadeInUpsLinkProps(item) : (doctorSection36FadeInUpsLinkProps ?? {}))} {...(typeof divDiv0Div1H30Link0LinkProps === "function" ? divDiv0Div1H30Link0LinkProps(item) : (divDiv0Div1H30Link0LinkProps ?? {}))}>{item.link0Text}</SmartLink>
                                                ))}
                                            </h3>
                                        ))}
                                        <p>{item.p0Text}</p>
                                    </div>
                                </div>
                            </div>
                        ),
                        doctorSection36FadeInUpsItemWrapper,
                        doctorSection36FadeInUpsRenderer
                    )}
                </div>
            </div>
        </section>
    );
};

export default HomeFourDoctorSectionGenerated;
